<template>
  <div class="w-full">
    <div class="w-full mb-base flex justify-between items-center">
      <h2>Surat Masuk</h2>
      <vs-button 
        v-if="$sanctum.canCreateSuratMasuk()"
        @click="$router.push({name: 'surat-masuk-buat'})"
        icon="icon-plus" 
        icon-pack="feather"
        >Buat Surat Masuk</vs-button
      >
    </div>
    <div class="w-full">
      <vs-tabs>
        <vs-tab label="Disposisi" icon-pack="feather" icon="icon-check-square">
          <ListDisposisi />
        </vs-tab>
        <vs-tab label="Konsep" icon-pack="feather" icon="icon-file">
          <ListKonsep />
        </vs-tab>
        <vs-tab label="Info Surat" icon-pack="feather" icon="icon-search">
          <ListInfo />
        </vs-tab>
        <vs-tab label="Sampah" icon-pack="feather" icon="icon-trash">
          <ListSampah />
        </vs-tab>
      </vs-tabs>
    </div>
  </div>
</template>

<script>
import ListDisposisi from "./components/ListDisposisi.vue";
import ListKonsep from "./components/ListKonsep.vue";
import ListInfo from "./components/ListInfo.vue";
import ListSampah from "./components/ListSampah.vue";

export default {
  components: {
    ListDisposisi,
    ListKonsep,
    ListInfo,
    ListSampah
  }
};
</script>
